<template>
  <div>
    <v-expansion-panels v-if="avaliacoes.length >= 1" v-model="panel" multiple focusable class="mt-4 mb-14">
      <v-expansion-panel v-for="(avaliacao, key) in avaliacoes" :key="key">
        <v-expansion-panel-header ripple>
          <v-row no-gutters align="center">
            <v-col class="text-left">{{ avaliacao.avaliacao }}</v-col>
          </v-row>
          <template v-slot:actions>
            <v-icon color="orangePcm">$expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="background">
          <LayoutRelatorioResumidoPesquisaSatisfacao
            :labelsNotas="mapKeys(avaliacao.notaTotal)"
            :valoresNotasTotal="mapValues(avaliacao.notaTotal)"
            :notasTotal="avaliacao.notaTotal"
            :labelNotasDiaCorrido="mapKeys(avaliacao.notaDiasCorridos)"
            :valoresNotasDiasCorrido="Object.values(avaliacao.notaDiasCorridos)"
            :avaliacoesPorHora="avaliacao.notaHora"
            :operadores="Object.keys(avaliacao.notaPorOperador)"
            :avaliacoesOperadores="Object.values(avaliacao.notaPorOperador)"
            :idFila="avaliacao.id"
          />
          
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else>
      <div class="text-h5">
        Não foram encontrados dados desta tabela.
      </div>
    </div>
  </div>
</template>

<script>
import LayoutRelatorioResumidoPesquisaSatisfacao from './LayoutRelatorioResumidoPesquisaSatisfacao'
export default {
  name: 'ExpansionListRelatorioResumidoPesquisaSatisfacao',
  components: { LayoutRelatorioResumidoPesquisaSatisfacao },
  props: {
    avaliacoes: Array,
  },
  data: () => ({
    panel: [],
    keys: []
  }),
  methods: {
    mapKeys(obj) {
      let chavesDoObjeto = []
      chavesDoObjeto = Object.keys(obj)

      chavesDoObjeto.sort(function(a, b){
        let aux1 = ''
        let aux2 = ''

        aux1 = a.split(" - ")[0]
        aux2 = b.split(" - ")[0]

        return aux1-aux2
      });
      
      return chavesDoObjeto
    },
    
    mapValues(obj){
      
      let chavesDoObjeto = []
      let paresDoObjeto = []
      let valoresDoObjeto = []

      chavesDoObjeto = Object.keys(obj)
      paresDoObjeto = Object.entries(obj)

      chavesDoObjeto.sort(function(a, b){
        let aux1 = ''
        let aux2 = ''

        aux1 = a.split(" - ")[0]
        aux2 = b.split(" - ")[0]

        return aux1-aux2
      });

      for (let i in chavesDoObjeto) {
        for (let j in paresDoObjeto) {
          if (chavesDoObjeto[i] == paresDoObjeto[j][0]) {
            valoresDoObjeto.push(paresDoObjeto[j][1])
          }
        }
      }
      return valoresDoObjeto
      
    },

  },
}
</script>
